// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OtvetyBanner_wrapper__7589r"};